import React from 'react';
import PropTypes from 'prop-types';
import { compose, not, prop } from 'ramda';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import Text from 'app/components/layout/Text.styled';
import { userCountryCode } from 'app/features/user/selectors';
import { isFreeProduct } from 'app/features/products/selectors';
import S from 'app/features/landing/productComparison/components/Product/Tax.styled';
import countriesTaxation from 'app/features/landing/productComparison/constants/countriesTaxation';

const UI = ({ countryCode }) => (
  <Text as={S.Tax} size="xs" type="heavy">
    <FormattedMessage
      id={countriesTaxation[countryCode] ?? 'landing_plans_applicable_taxes'}
    />
  </Text>
);

UI.propTypes = {
  countryCode: PropTypes.string.isRequired,
};

UI.displayName = 'Tax';

const state = {
  isFree: isFreeProduct,
  countryCode: userCountryCode,
};

const Tax = compose(connect(state), renderIf(compose(not, prop('isFree'))))(UI);

export { UI };

export default Tax;
